/* eslint-disable array-bracket-spacing */
/* eslint-disable computed-property-spacing */
/* eslint-disable template-curly-spacing */
/* eslint-disable react/jsx-curly-spacing */
import React, { Component } from "react";
import { DetilPxContext } from "../../../context";
import TableServerSidePagination from "../../component/ServerSideTable/TableServerSidePagination";
import moment from "moment";
import usePuskesmas from "../../hooks/usePuskesmas";
import apiService from "../../../apiService";
import { confirmedAlert, showLoading, toast } from "../../component/Alert";

class TablePelayanan extends Component {
  static contextType = DetilPxContext;

  constructor(props) {
    super(props);
    this.state = {
      headers: props.headers,
      datas: [],
      wa: [],
      filteredDatas: [],
      isLoading: true,
      currentPage: 1,
      form: false,
      detilPx: "",
      index: "",
      modal: false,
      modalProlanis: false,
      modalData: "",
    };
    this.generateInfoWa = this.generateInfoWa.bind(this);
    this.sendWa = this.sendWa.bind(this);
    this.generateName = this.generateName.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.datas !== prevProps.datas) {
      this.setState({
        datas: this.props.datas,
        filteredDatas: this.props.datas,
        isLoading: false,
        wa: this.props.wa,
      });
    }
  }

  getComponentRef = (i) => {
    return this.cardNameComponentRefs[i];
  };

  handlePageChange = (pageNumber) => {
    this.setState({
      currentPage: pageNumber,
    });
  };

  handleFilter = (flag) => {
    const filteredLists = [];
    if (flag !== "") {
      this.state.datas.map((data) => {
        if (data.flg_prolanis === flag) {
          filteredLists.push(data);
        }
        return "";
      });
      this.setState({
        filteredDatas: filteredLists,
        currentPage: 1,
      });
    } else {
      this.setState({
        filteredDatas: this.state.datas,
      });
    }
    return "";
  };

  sendWa = async (data) => {
    let param = {
      number: data.phone_number,
      message: data.message,
    };
    let res = await apiService.post(
      "http://110.76.148.125:8000/send-message",
      param
    );
    if (res) {
      console.log(res);
    }
  };

  generateInfoWa = (data, bulan) => {
    let wa = this.state.wa;
    let dat = "-";
    if (wa[data.patient_id]) {
      let pesan = wa[data.patient_id];
      let ketemu = pesan.find((e) => moment(e["due_date"]).month() == bulan);
      //jika ketemu Ketemu duedate nya
      if (ketemu !== undefined) {
        dat = `${ketemu.due_date} ${ketemu.sent ? "terkirim" : "kirim"}`;
        if (ketemu.due_date) {
          if (ketemu.sent) {
            dat = "terkirim";
          } else {
            dat = (
              <div>
                {ketemu.due_date}{" "}
                <span
                  href="#"
                  className="tag badge badge-primary"
                  onClick={() => this.sendWa(ketemu)}
                >
                  kirim
                </span>
              </div>
            );
          }
        }
      } else {
        //jika tak ketemu duedatenya cari kapan kunjungannya
        let visit = pesan.find(
          (e) => moment(e.visit.created_at).month() == bulan
        );
        console.log(visit, bulan);
        if (visit !== undefined) {
          dat = "diambil";
        } else {
          dat = "-";
        }
      }
    }

    return dat;
  };

  generateName = (data) => {
    let name = `${data.patients.name} ${data.patients.last_name}`;
    let generate = (
      <div>
        {name} <button className="btn btn-sm btn-primary">pendamping</button>
      </div>
    );
    return generate;
  };

  render() {
    return (
      <div>
        <TableServerSidePagination
          headers={this.state.headers}
          columnMapper={(data, i) => [
            this.generateName(data),
            data.family_folder,
            data.patients.nik,
            this.generateInfoWa(data, 1),
            this.generateInfoWa(data, 2),
            this.generateInfoWa(data, 3),
            this.generateInfoWa(data, 4),
            this.generateInfoWa(data, 5),
            this.generateInfoWa(data, 6),
            this.generateInfoWa(data, 7),
            this.generateInfoWa(data, 8),
            this.generateInfoWa(data, 9),
            this.generateInfoWa(data, 10),
            this.generateInfoWa(data, 11),
            this.generateInfoWa(data, 12),
          ]}
          data={this.state.filteredDatas}
          url={"registration/read"}
          bodyRequest={this.props.keyword}
          callback={this.changeData}
        />
      </div>
    );
  }
}

export default usePuskesmas(TablePelayanan);
